export default {
  trip: ['trip_management']
}
